import React, { useMemo, useState } from "react";
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   FormLabel,
//   Grid,
//   IconButton,
//   MenuItem,
//   InputLabel,
//   Select,
//   FormControl,
//   Paper,
//   Divider,
//   Stack,
//   InputAdornment,
//   Tooltip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
// } from "@mui/material";
import {
  Add,
  Delete,
  Close,
  PhotoCamera,
  Phone,
  Badge as BadgeIcon,
  Person,
  DirectionsCar,
  PersonAddAlt,
  
} from "@mui/icons-material";

import {
  Tooltip,
} from "@mui/material";
import provinces from "../../provinces.json";
import { Toaster } from "react-hot-toast";
import CAR_TYPES from "./../../utils/variable";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";

const Section = ({ title, children, action }) => (
  <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm relative overflow-visible">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-lg font-bold text-gray-800">{title}</h3>
      {action}
    </div>
    <div className="w-full h-px bg-gray-100 mb-6" />
    {children}
  </div>
);

// Simple Tailwind Modal
const Modal = ({ isOpen, onClose, title, children, actions }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity" 
        onClick={onClose}
      />
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md z-10 overflow-hidden animate-scale-in">
        <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-gray-50/50">
           <h3 className="text-lg font-bold text-gray-800">{title}</h3>
           <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <Close />
           </button>
        </div>
        <div className="p-6 max-h-[70vh] overflow-y-auto">
           {children}
        </div>
        <div className="p-4 border-t border-gray-100 bg-gray-50/50 flex justify-end gap-2">
           {actions}
        </div>
      </div>
    </div>
  );
};

const PersonalInfoForm = ({
  readCard,
  formData,
  handleChange,
  customerGroups,
  group,
  setGroup,
  personType,
  setPersonType,
  cars = [],
  drivers = [],
  handleAddCar, // (car) => void   // เราจะเรียกตอนกดบันทึกใน Dialog
  handleAddDriver, // (driver) => void
  handleDeleteCar,
  handleDeleteDriver,
  handleCarChange,
  handleDriverChange,
  handleSubmit,
}) => {
  // ----- Dialog states -----
  const [carOpen, setCarOpen] = useState(false);
  const [driverOpen, setDriverOpen] = useState(false);

  // ฟอร์มชั่วคราวใน dialog
  const [newCar, setNewCar] = useState({ type: "", license: "", province: "" });
  const [newDriver, setNewDriver] = useState({
    name: "",
    surname: "",
    idCard: "",
  });

  // error states สำหรับ validate
  const [carErr, setCarErr] = useState({ type: "", license: "", province: "" });
  const [driverErr, setDriverErr] = useState({
    name: "",
    surname: "",
    idCard: "",
  });

  // อัปโหลดและพรีวิวรูปโปรไฟล์
  const handleProfileImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      handleChange("img")({ target: { value: reader.result } });
    };
    reader.readAsDataURL(file);
  };

  // ----- Dialog handlers: Car -----
  const openCarDialog = () => {
    setNewCar({ type: "", license: "", province: "" });
    setCarErr({ type: "", license: "", province: "" });
    setCarOpen(true);
  };
  const closeCarDialog = () => setCarOpen(false);

  const saveCar = () => {
    // validate เบื้องต้น
    const nextErr = { type: "", license: "", province: "" };
    if (!newCar.type.trim()) nextErr.type = "กรุณาเลือกประเภทรถ";
    if (!newCar.license.trim()) nextErr.license = "กรุณากรอกทะเบียนรถ";
    if (!newCar.province.trim()) nextErr.province = "กรุณาเลือกจังหวัด";
    setCarErr(nextErr);

    const hasError = Object.values(nextErr).some(Boolean);
    if (hasError) return;

    // call parent handler
    handleAddCar({
      type: newCar.type,
      license: newCar.license,
      province: newCar.province,
    });
    setCarOpen(false);
  };

  // ----- Dialog handlers: Driver -----
  const openDriverDialog = () => {
    setNewDriver({ name: "", surname: "", idCard: "" });
    setDriverErr({ name: "", surname: "", idCard: "" });
    setDriverOpen(true);
  };
  const closeDriverDialog = () => setDriverOpen(false);

  const saveDriver = () => {
    const nextErr = { name: "", surname: "", idCard: "" };
    if (!newDriver.name.trim()) nextErr.name = "กรุณากรอกชื่อ";
    if (!newDriver.surname.trim()) nextErr.surname = "กรุณากรอกนามสกุล";
    if (!newDriver.idCard.trim()) nextErr.idCard = "กรุณากรอกเลขบัตรประชาชน";
    setDriverErr(nextErr);

    const hasError = Object.values(nextErr).some(Boolean);
    if (hasError) return;

    handleAddDriver({
      name: newDriver.name,
      surname: newDriver.surname,
      idCard: newDriver.idCard,
    });
    setDriverOpen(false);
  };

  const groupAdornment = useMemo(
    () =>
      group ? (
        <button 
           onClick={() => setGroup("")}
           className="absolute right-8 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
        >
          <Close style={{ fontSize: 16 }} />
        </button>
      ) : null,
    [group, setGroup]
  );

  const InputClass = "bg-white border border-gray-200 text-gray-900 text-sm rounded-xl focus:ring-green-500 focus:border-green-500 block w-full p-2.5 outline-none transition-all shadow-sm";
  const LabelClass = "block mb-1.5 text-sm font-medium text-gray-700";

  return (
    <div className="max-w-6xl mx-auto">
      <Toaster position="bottom-right" reverseOrder={false} />

      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">ข้อมูลลูกค้า</h2>
          <p className="text-gray-500 text-sm mt-1">กรอกข้อมูลให้ครบถ้วน</p>
        </div>
        <div className="flex gap-3">
          <button 
             onClick={readCard}
             className="px-4 py-2 rounded-xl border border-gray-200 bg-white text-gray-700 font-medium hover:bg-gray-50 transition-colors shadow-sm"
          >
             ดึงข้อมูลบัตรประชาชน
          </button>
          
          {/* Note: handleSubmit button is usually in parent, but kept here if original had it. Original Layout had it in header. */}
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6">
        {/* โปรไฟล์ + ประเภทบุคคล */}
        <div className="col-span-12 md:col-span-4">
          <Section
            title="รูป"
          >
            <div className="flex flex-col items-center mb-6">
              <div
                className="relative w-48 h-48 bg-gray-50 rounded-2xl overflow-hidden border-2 border-dashed border-gray-200 flex items-center justify-center group"
              >
                {formData?.img ? (
                  <img
                    src={formData.img}
                    alt="รูปโปรไฟล์"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="flex flex-col items-center text-gray-300">
                    <ImageNotSupportedIcon style={{ fontSize: 64 }} />
                    <span className="text-xs mt-2">ไม่มีรูปภาพ</span>
                  </div>
                )}
              </div>
            </div>

            <div className="mb-2 text-sm font-medium text-gray-700">ประเภทบุคคล</div>
            <div className="flex gap-4">
               <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="personType"
                    value="normal"
                    checked={personType === "normal"}
                    onChange={(e) => setPersonType(e.target.value)}
                    className="w-4 h-4 text-green-600 focus:ring-green-500 border-gray-300"
                  />
                  <span className="text-sm text-gray-700">บุคคลธรรมดา</span>
               </label>
               <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="personType"
                    value="corporate"
                    checked={personType === "corporate"}
                    onChange={(e) => setPersonType(e.target.value)}
                    className="w-4 h-4 text-green-600 focus:ring-green-500 border-gray-300"
                  />
                  <span className="text-sm text-gray-700">นิติบุคคล</span>
               </label>
            </div>
          </Section>
        </div>

        <div className="col-span-12 md:col-span-8">
          <Section title="รายละเอียดลูกค้า">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className={LabelClass}>ชื่อ-นามสกุล <span className="text-red-500">*</span></label>
                <div className="relative">
                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                      <Person fontSize="small" />
                   </div>
                   <input
                      type="text"
                      className={`${InputClass} pl-10`}
                      value={formData.name || ""}
                      onChange={handleChange("name")}
                   />
                </div>
              </div>

              {personType !== "corporate" && (
                <div>
                  <label className={LabelClass}>วันเดือนปีเกิด</label>
                  <input
                    type="date"
                    className={InputClass}
                    value={formData.dob || ""}
                    onChange={handleChange("dob")}
                  />
                </div>
              )}

              <div>
                <label className={LabelClass}>
                   {personType !== "corporate" ? "เลขบัตรประชาชน" : "เลขประจำตัวผู้เสียภาษี"}
                </label>
                <div className="relative">
                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                      <BadgeIcon fontSize="small" />
                   </div>
                   <input
                      type="text"
                      className={`${InputClass} pl-10`}
                      value={formData.citizenId || ""}
                      onChange={handleChange("citizenId")}
                   />
                </div>
              </div>

              <div>
                <label className={LabelClass}>เบอร์โทรศัพท์</label>
                <div className="relative">
                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                      <Phone fontSize="small" />
                   </div>
                   <input
                      type="text"
                      className={`${InputClass} pl-10`}
                      value={formData.phone || ""}
                      onChange={handleChange("phone")}
                   />
                </div>
              </div>

              <div className="col-span-1 md:col-span-2">
                 <label className={LabelClass}>กลุ่ม</label>
                 <div className="relative">
                    <select
                       value={group}
                       onChange={(e) => setGroup(e.target.value)}
                       className={`${InputClass} appearance-none pr-8`}
                    >
                       <option value="">เลือกกลุ่ม...</option>
                       {customerGroups.map((item) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                       ))}
                    </select>
                    {groupAdornment}
                 </div>
              </div>

              <div className="col-span-1 md:col-span-2">
                 <label className={LabelClass}>ที่อยู่</label>
                 <textarea
                    rows={3}
                    className={InputClass}
                    value={formData.address || ""}
                    onChange={handleChange("address")}
                 />
              </div>
            </div>
          </Section>
        </div>

        {/* รถขนส่ง */}
        <div className="col-span-12">
          <Section
            title="รถขนส่ง"
            action={
              <button 
                 onClick={openCarDialog}
                 className="flex items-center gap-1.5 px-3 py-1.5 bg-green-50 text-green-700 hover:bg-green-100 rounded-lg text-sm font-medium transition-colors"
              >
                <Add fontSize="small" />
                เพิ่มรถ
              </button>
            }
          >
            {cars.length === 0 ? (
              <div className="text-center py-8 bg-gray-50 rounded-xl border border-dashed border-gray-200 text-gray-400">
                 <DirectionsCar style={{ fontSize: 40, opacity: 0.5 }} className="mb-2" />
                 <p className="text-sm">ยังไม่มีรถในรายการ กด “เพิ่มรถ” ได้เลย</p>
              </div>
            ) : (
              <div className="space-y-3">
                {cars.map((car, index) => (
                  <div
                    key={`${car.license}-${index}`}
                    className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex flex-col md:flex-row items-end md:items-center gap-4 group hover:border-green-200 transition-colors"
                  >
                     <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                        <div>
                           <label className="text-xs text-gray-500 mb-1 block">ประเภทรถ</label>
                           <select
                              value={car.type || ""}
                              onChange={(e) => handleCarChange(index, "type", e.target.value)}
                              className={InputClass}
                           >
                              <option value="">เลือกประเภท...</option>
                              {CAR_TYPES.map((t) => (
                                 <option key={t} value={t}>{t}</option>
                              ))}
                           </select>
                        </div>
                        <div>
                           <label className="text-xs text-gray-500 mb-1 block">ทะเบียนรถ</label>
                           <input
                              type="text"
                              value={car.license || ""}
                              onChange={(e) => handleCarChange(index, "license", e.target.value)}
                              className={InputClass}
                           />
                        </div>
                        <div>
                           <label className="text-xs text-gray-500 mb-1 block">จังหวัด</label>
                           <select
                              value={car.province || ""}
                              onChange={(e) => handleCarChange(index, "province", e.target.value)}
                              className={InputClass}
                           >
                              <option value="">เลือกจังหวัด...</option>
                              {provinces.map((name) => (
                                 <option key={name} value={name}>{name}</option>
                              ))}
                           </select>
                        </div>
                     </div>
                     <button
                        onClick={() => handleDeleteCar(index)}
                        className="p-2.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                     >
                        <Delete />
                     </button>
                  </div>
                ))}
              </div>
            )}
          </Section>
        </div>

        {/* คนขับ */}
        <div className="col-span-12">
          <Section
            title="คนขับ"
            action={
              <button 
                 onClick={openDriverDialog}
                 className="flex items-center gap-1.5 px-3 py-1.5 bg-green-50 text-green-700 hover:bg-green-100 rounded-lg text-sm font-medium transition-colors"
              >
                <PersonAddAlt fontSize="small" />
                เพิ่มคนขับ
              </button>
            }
          >
            {drivers.length === 0 ? (
              <div className="text-center py-8 bg-gray-50 rounded-xl border border-dashed border-gray-200 text-gray-400">
                 <Person style={{ fontSize: 40, opacity: 0.5 }} className="mb-2" />
                 <p className="text-sm">ยังไม่มีคนขับในรายการ กด “เพิ่มคนขับ” ได้เลย</p>
              </div>
            ) : (
              <div className="space-y-3">
                {drivers.map((d, index) => (
                  <div
                    key={`${d.idCard || index}-${index}`}
                    className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm relative group hover:border-green-200 transition-colors"
                  >
                     <div className="absolute top-2 right-2">
                         <button
                             onClick={() => handleDeleteDriver(index)}
                             className="p-1.5 text-gray-300 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                          >
                             <Delete fontSize="small" />
                          </button>
                     </div>
                     
                     <div className="flex flex-col md:flex-row gap-6">
                        {/* Driver Image */}
                        <div className="w-full md:w-auto flex justify-center flex-shrink-0">
                           <div className="w-24 h-24 bg-gray-100 rounded-xl flex items-center justify-center overflow-hidden border border-gray-200 relative">
                              {d?.img ? (
                                 <img src={d.img} alt="Driver" className="w-full h-full object-cover" />
                              ) : (
                                 <Person className="text-gray-300" style={{ fontSize: 40 }} />
                              )}
                           </div>
                        </div>

                        {/* Driver Inputs */}
                        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                            <div className="lg:col-span-2">
                                <label className="text-xs text-gray-500 mb-1 block">ชื่อ</label>
                                <input
                                   type="text"
                                   value={d.name || ""}
                                   onChange={(e) => handleDriverChange(index, "name", e.target.value)}
                                   className={InputClass}
                                />
                            </div>
                            <div className="lg:col-span-2">
                                <label className="text-xs text-gray-500 mb-1 block">นามสกุล</label>
                                <input
                                      type="text"
                                      value={d.surname || ""}
                                      onChange={(e) => handleDriverChange(index, "surname", e.target.value)}
                                      className={InputClass}
                                />
                            </div>
                            
                            <div>
                                <label className="text-xs text-gray-500 mb-1 block">เลขบัตรประชาชน</label>
                                <input
                                      type="text"
                                      value={d.idCard || ""}
                                      onChange={(e) => handleDriverChange(index, "idCard", e.target.value)}
                                      className={InputClass}
                                />
                            </div>
                            <div>
                                <label className="text-xs text-gray-500 mb-1 block">เบอร์โทรศัพท์</label>
                                <input
                                      type="text"
                                      value={d.phone || ""}
                                      onChange={(e) => handleDriverChange(index, "phone", e.target.value)}
                                      className={InputClass}
                                />
                            </div>
                            <div>
                                <label className="text-xs text-gray-500 mb-1 block">วันเกิด</label>
                                <input
                                      type="date"
                                      value={d.birthday || ""}
                                      onChange={(e) => handleDriverChange(index, "birthday", e.target.value)}
                                      className={InputClass}
                                />
                            </div>
                            <div>
                                <label className="text-xs text-gray-500 mb-1 block">บัตรหมดอายุ</label>
                                <input
                                      type="date"
                                      value={d.expire || ""}
                                      onChange={(e) => handleDriverChange(index, "expire", e.target.value)}
                                      className={InputClass}
                                />
                            </div>
                        </div>
                     </div>
                  </div>
                ))}
              </div>
            )}
          </Section>
        </div>
      </div>

      {/* ---------------- Modal: เพิ่มรถ ---------------- */}
      <Modal
         isOpen={carOpen}
         onClose={closeCarDialog}
         title="เพิ่มรถขนส่ง"
         actions={
            <>
               <button 
                  onClick={closeCarDialog}
                  className="px-4 py-2 text-gray-600 font-medium hover:bg-gray-100 rounded-lg transition-colors"
               >
                  ยกเลิก
               </button>
               <button 
                  onClick={saveCar}
                  className="px-4 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors shadow-sm"
               >
                  เพิ่มข้อมูล
               </button>
            </>
         }
      >
         <div className="grid grid-cols-1 gap-4">
            <div>
               <label className={LabelClass}>ประเภทรถ <span className="text-red-500">*</span></label>
               <select
                  value={newCar.type}
                  onChange={(e) => setNewCar((s) => ({ ...s, type: e.target.value }))}
                  className={`${InputClass} ${carErr.type ? "border-red-500 focus:border-red-500 focus:ring-red-200" : ""}`}
               >
                  <option value="">เลือกประเภท...</option>
                  {CAR_TYPES.map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
               </select>
               {carErr.type && <p className="text-red-500 text-xs mt-1">{carErr.type}</p>}
            </div>
            
            <div>
               <label className={LabelClass}>ทะเบียนรถ <span className="text-red-500">*</span></label>
               <input
                  type="text"
                  value={newCar.license}
                  onChange={(e) => setNewCar((s) => ({ ...s, license: e.target.value }))}
                  className={`${InputClass} ${carErr.license ? "border-red-500 focus:border-red-500 focus:ring-red-200" : ""}`}
               />
               {carErr.license && <p className="text-red-500 text-xs mt-1">{carErr.license}</p>}
            </div>

            <div>
               <label className={LabelClass}>จังหวัด <span className="text-red-500">*</span></label>
               <select
                  value={newCar.province}
                  onChange={(e) => setNewCar((s) => ({ ...s, province: e.target.value }))}
                  className={`${InputClass} ${carErr.province ? "border-red-500 focus:border-red-500 focus:ring-red-200" : ""}`}
               >
                  <option value="">เลือกจังหวัด...</option>
                  {provinces.map((name) => (
                    <option key={name} value={name}>{name}</option>
                  ))}
               </select>
               {carErr.province && <p className="text-red-500 text-xs mt-1">{carErr.province}</p>}
            </div>
         </div>
      </Modal>

      {/* ---------------- Modal: เพิ่มคนขับ ---------------- */}
      <Modal
         isOpen={driverOpen}
         onClose={closeDriverDialog}
         title="เพิ่มคนขับ"
         actions={
            <>
               <button 
                  onClick={closeDriverDialog}
                  className="px-4 py-2 text-gray-600 font-medium hover:bg-gray-100 rounded-lg transition-colors"
               >
                  ยกเลิก
               </button>
               <button 
                  onClick={saveDriver}
                  className="px-4 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors shadow-sm"
               >
                  เพิ่มข้อมูล
               </button>
            </>
         }
      >
         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
             <div>
               <label className={LabelClass}>ชื่อ <span className="text-red-500">*</span></label>
               <input
                  type="text"
                  value={newDriver.name}
                  onChange={(e) => setNewDriver((s) => ({ ...s, name: e.target.value }))}
                  className={`${InputClass} ${driverErr.name ? "border-red-500 focus:border-red-500 focus:ring-red-200" : ""}`}
               />
               {driverErr.name && <p className="text-red-500 text-xs mt-1">{driverErr.name}</p>}
             </div>
             <div>
               <label className={LabelClass}>นามสกุล <span className="text-red-500">*</span></label>
               <input
                  type="text"
                  value={newDriver.surname}
                  onChange={(e) => setNewDriver((s) => ({ ...s, surname: e.target.value }))}
                  className={`${InputClass} ${driverErr.surname ? "border-red-500 focus:border-red-500 focus:ring-red-200" : ""}`}
               />
               {driverErr.surname && <p className="text-red-500 text-xs mt-1">{driverErr.surname}</p>}
             </div>
             <div className="md:col-span-2">
               <label className={LabelClass}>เลขบัตรประชาชน <span className="text-red-500">*</span></label>
               <input
                  type="text"
                  value={newDriver.idCard}
                  onChange={(e) => setNewDriver((s) => ({ ...s, idCard: e.target.value }))}
                  className={`${InputClass} ${driverErr.idCard ? "border-red-500 focus:border-red-500 focus:ring-red-200" : ""}`}
               />
               {driverErr.idCard && <p className="text-red-500 text-xs mt-1">{driverErr.idCard}</p>}
             </div>
         </div>
      </Modal>
    </div>
  );
};

export default PersonalInfoForm;
